import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import i18n from '@/lib/i18n'
import { SUPPORTED_LANGS } from '@/hooks/useLang'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { NotFoundContent } from '@/components/NotFoundContent'

export const Route = createFileRoute('/$lang')({
  beforeLoad: async ({ params }) => {
    if (!SUPPORTED_LANGS.includes(params.lang as typeof SUPPORTED_LANGS[number])) {
      // On the server, don't read i18n.resolvedLanguage — it's a shared singleton
      // that leaks between requests. Always fall back to 'en'.
      throw redirect({ to: '/$lang', params: { lang: 'en' }, replace: true })
    }
    await i18n.changeLanguage(params.lang)
  },
  component: PublicLayout,
  notFoundComponent: NotFoundContent,
})

function PublicLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
